import { render } from "./PageReciep.vue?vue&type=template&id=79f68c9f&scoped=true"
import script from "./PageReciep.vue?vue&type=script&lang=js"
export * from "./PageReciep.vue?vue&type=script&lang=js"

import "./PageReciep.vue?vue&type=style&index=0&id=79f68c9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f68c9f"]])

export default __exports__